<template>
    <fieldset :disabled="!isEditing.value">
        <div class="title bg-success">Parceiro</div>

        <div class="col-md-6">
            <label for="nome" class="col-form-label">Nome</label>
            <input v-model="partner.name" id="nome" class="form-control">
        </div>

        <div class="col-md-6">
            <label for="ucname" class="col-form-label">Telefone</label>
            <input v-model="partner.phone" id="site" class="form-control">
        </div>

        <div class="col-md-6">
            <label for="ucname" class="col-form-label">Número de contato</label>
            <input v-model="partner.contactNumber" id="site" class="form-control">
        </div>

        <div class="col-md-6">
            <label for="ucname" class="col-form-label">ID ERP</label>
            <input v-model="partner.idErp" id="site" class="form-control">
        </div>
        <button v-if="isEditing.value" type="button" class="actions btn btn-primary btn-sm" @click="savePartner">
            Salvar
        </button>
    </fieldset>
</template>

<script>
import { PartnerService } from "@/services/backend/ApiService";
import useEditMode from "@/services/EditingService";

export default {
    components: {},
    data() {
        return {
            partner: Object,
        };
    },
    setup() {
        const isEditing = useEditMode();

        return { isEditing };
    },
    methods: {
        async loadPartnerData(id) {
            try {
                this.partner = await PartnerService.findOne(id);

                this.updateUniqueHosts();
            } catch (error) {
                console.error("Erro ao carregar os dados do POP:", error);
            }
        },
        async savePartner() {
            await PartnerService.update(this.partner.id, this.partner);
        },

    },
    mounted() {
        const partnerId = this.$route.params.id;

        if (partnerId) {
            this.loadPartnerData(partnerId);
        }
    }
};
</script>


<style scoped>
select {
    margin-bottom: 30px
}

option[disabled] {
    background: rgb(221, 221, 221);
}
</style>